import ExportPatrimoinePerLocalisationForm from './export-patrimone-per-localisation';
import PricingPreviewModal from './situation/pricing-preview-modal';
import {MODAL} from 'features/modal-notch/constants';

export default {
  [MODAL.PRICING_SITUATIONS]: PricingPreviewModal,
  [MODAL.EXPORT_PATRIMOINE]: ExportPatrimoinePerLocalisationForm,
  
};
